"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        this.state = { selectedList: [] };
        GState.bind(this, [
            'user',
            'tenant'
        ]);
        this.state.selectedList = this.state.user.learner.categories || [];
        this.subCategories = [];
        const collector = function (arrayList) {
            arrayList.map(({categoryId, name, description, poster, subs}) => {
                this.subCategories.push({
                    categoryId,
                    name,
                    description,
                    poster
                });
                if (!!subs && !isEmpty(subs))
                    collector(Object.values(subs));
            });
        }.bind(this);
        this.mainCategories = Object.values(this.state.tenant.categories).map(({categoryId, name, description, poster, subs}) => {
            if (!!subs && !isEmpty(subs))
                collector(Object.values(subs));
            return {
                categoryId,
                name,
                description,
                poster
            };
        });
    },
    onSelect: async function (id) {
        let list = this.state.selectedList;
        list = !list.includes(id) ? [...new Set([
                ...list,
                id
            ])] : list.filter(each => {
            return each != id;
        });
        this.state.selectedList = list;
        GState.user.update({ categories: list.length ? list : null }, 'learner');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Settings/Learner/sections/Categories.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Image_template = require("../../../../../components/Image/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Image_tag = marko_loadTag(Image_template),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    WSAdapt_template = require("../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    Bx_template = require("../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    Row_template = require("../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "card-content"
      },
    marko_attrs1 = {
        "class": "py-75 text-center"
      },
    marko_attrs2 = {
        "class": "d-flex align-items-center",
        style: "height:50vh"
      },
    marko_attrs3 = {
        "class": "w-100 text-center"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("8d5b81"),
    marko_node0 = marko_createElement("br", null, "9", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node1 = marko_createElement("br", null, "10", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs4 = {
        "class": "font-medium-2"
      },
    marko_node2 = marko_createElement("br", null, "15", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node3 = marko_createElement("hr", null, "17", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "18", null, 0, 0, {
        i: marko_const_nextId()
      });

function render(input, out, __component, component, state) {
  var data = input;

  function macro_Category(out, { categoryId, name, description, poster }) {
    const isSelected = state.selectedList.includes( categoryId )

    WSAdapt_tag({
        ns: "col-md-2 col-6",
        qs: "col-md-3 col-6",
        hs: "col-md-4 col-6",
        renderBody: function(out) {
          out.be("div", {
              "class": "card cursor-pointer shadow-none theme-bg rounded-0",
              title: Locale(description)
            }, "1", component, null, 0, {
              onclick: __component.d("click", "onSelect", false, [
                  categoryId
                ])
            });

          out.be("div", marko_attrs0, "2", component);

          Image_tag({
              alt: "Image",
              src: poster,
              class: "img-fluid rounded w-100 border " + (isSelected ? "border-color-primary border-3" : ""),
              style: "min-height:100px"
            }, out, __component, "3");

          out.be("div", marko_attrs1, "4", component);

          Locale_tag({
              text: name,
              class: "font-medium-2 "
            }, out, __component, "5");

          out.ee();

          out.ee();

          out.ee();
        }
      }, out, __component, "0");
  }

  if (isEmpty(component.mainCategories)) {
    out.be("div", marko_attrs2, "6", component);

    out.be("div", marko_attrs3, "7", component);

    Bx_tag({
        type: "tag",
        class: "font-large-3 text-muted"
      }, out, __component, "8");

    out.n(marko_node0, component);

    out.n(marko_node1, component);

    out.be("p", null, "11", component);

    Locale_tag({
        renderBody: function(out) {
          out.t("No Category Found");
        }
      }, out, __component, "12");

    out.ee();

    out.ee();

    out.ee();
  } else {
    out.be("div", marko_attrs4, "13", component);

    Locale_tag({
        renderBody: function(out) {
          out.t("Which categories of course or program are you interected in?");
        }
      }, out, __component, "14");

    out.ee();

    out.n(marko_node2, component);

    Row_tag({
        renderBody: function(out) {
          var $for$0 = 0;

          marko_forOf(component.mainCategories, function(category) {
            var $keyScope$0 = "[" + (($for$0++) + "]");

            marko_dynamicTag(out, macro_Category, function() {
              return category;
            }, null, null, null, __component, "20" + $keyScope$0);
          });
        }
      }, out, __component, "16");

    out.n(marko_node3, component);

    out.n(marko_node4, component);

    Row_tag({
        renderBody: function(out) {
          var $for$1 = 0;

          marko_forOf(component.subCategories, function(category) {
            var $keyScope$1 = "[" + (($for$1++) + "]");

            marko_dynamicTag(out, macro_Category, function() {
              return category;
            }, null, null, null, __component, "21" + $keyScope$1);
          });
        }
      }, out, __component, "19");
  }
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
